import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-keyboard_arrow_right",
  "use": "icon-keyboard_arrow_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-keyboard_arrow_right\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol